import { formatNumberWithCommas } from '@/helpers/utility';
import React, { PureComponent } from 'react';

export class CustomYAxisTick extends PureComponent {
  render() {
    const { x, y, payload, yAxisUnit, dy, textAnchor, fill, label, maxValue } = this.props;
    const isMaxValue = payload.value === maxValue; // Check if this is the highest tick value being rendered
    return (
      <g transform={`translate(${x},${y})`}>
        {isMaxValue && (
          <text
            x={0}
            y={-20}
            dx={textAnchor === 'start' ? 8 : 0}
            dy={dy ?? 0}
            fontSize={'12px'}
            fontWeight={'700'}
            fontFamily={'DM Sans'}
            textAnchor={textAnchor ?? 'start'}
            dominantBaseline="middle"
            fill={fill || "#A2A8BB"}
          >
            {label}
          </text>
        )}
        <text
          x={0}
          y={0}
          dx={textAnchor === 'start' ? 8 : 0}
          dy={dy ?? 0}
          fontSize={'12px'}
          fontWeight={'700'}
          fontFamily={'DM Sans'}
          textAnchor={textAnchor ?? 'start'}
          dominantBaseline="middle"
          fill={fill || "#A2A8BB"}
        >
          {`${formatNumberWithCommas(payload.value)}${yAxisUnit ?? ''}`}
        </text>
      </g>
    );
  }
}
